import { photobooks } from "@/mocks/resources";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Photobooks() {
  return (
    <section id="photobooks" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="写真合集"
          icon="ri-user-3-line"
          title="精选写真合集 · 成套场景与色调"
          desc="写真合集按拍摄场景与整体色调成组整理，每组包含张数、拍摄地点与内容说明。封面以竖版构图呈现，方便在浏览时快速判断风格是否符合偏好。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {photobooks.map((book) => (
            <article
              key={book.id}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200 flex flex-col sm:flex-row lg:flex-col"
            >
              <div className="relative w-full sm:w-[150px] lg:w-full h-[220px] lg:h-[300px] shrink-0 overflow-hidden bg-foreground-900">
                <img
                  src={book.cover}
                  alt={`色虎写真合集：${book.title}`}
                  title={`${book.title} 在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-[11px] font-medium">
                  {book.count} 张
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                  {book.title}
                </h3>
                <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-camera-line"></i>
                    {book.model}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-map-pin-line"></i>
                    {book.place}
                  </span>
                </div>
                <p className="mt-3 text-xs md:text-sm leading-relaxed text-foreground-600 flex-1">
                  {book.desc}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 cursor-pointer">
                  查看合集
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}